<div class="container">
    <div class="row mt-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb fqg f18">
                <li class="mr-3">
                    <a href="/index"><img src="/assets/images/icon-yurt.png" alt="home"></a>
                </li>
                <li aria-current="page" class="breadcrumb-item active"><span class="mgl"></span></li>
            </ol>
        </nav>
    </div>
</div>
<div class="container d-flex">
    <div class="search_cont">
        <div class="mgl"><input type="text" placeholder=" ᠠᠭᠤᠯᠭ᠎ᠠ ᠪᠠᠨ ᠡᠨᠳᠡ ᠪᠢᠴᠢᠨ᠎ᠡ ᠦᠦ" class="m_search fqg ng-untouched ng-pristine ng-valid"></div>
        <div class="mgl"><button class="m_btn fqg"></button></div>
    </div>
    <div class="search_content w-100">
        <div style="overflow-x: auto;">
            <ul class="s_c_list">
                <!---->
            </ul>
        </div>
    </div>
</div>